import React, { useState } from 'react'
import parse from 'html-react-parser'
import * as E from '../../elementor'
import ChevronDown from '../../images/chevron_down_black.svg'
import ChevronUp from '../../images/chevron_up_black.svg'

interface AccordionProps {
  accordion: E.AccordionWidget
  template?: string
}

const Accordion = ({ accordion, template }: AccordionProps) => {
  const { items } = accordion
  const [activeItem, setActiveItem] = useState<number | null>(null)

  const isActive = (index: number) => {
    return activeItem === index
  }

  const toggleItem = (index: number) => {
    if (activeItem === index) {
      setActiveItem(null)
    } else {
      setActiveItem(index)
    }
  }

  return (
    <div className='accordion-wrapper'>
      {items?.map((item, index) => {
        return (
          <div className='accordion-item-wrapper'>
            <button aria-controls='faq-accordion-content' aria-expanded={isActive(index)} className='accordion-item-header' onClick={() => toggleItem(index)}>
              {!!template && template === 'therapy-type' ? (
                <p className='paragraph-bold'>{parse(item.title)}</p>
              ) : (
                <h4>{parse(item.title)}</h4>
              )}
              <img src={isActive(index) ? ChevronUp : ChevronDown} alt={isActive(index) ? 'close item' : 'open item'} />
            </button>
            <div hidden={!isActive(index)} id={`faq-accordion-content-${index}`} className={`accordion-item-content ${activeItem === index ? 'active' : ''}`}>
              {parse(item.content)}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Accordion
